import React, { Component } from 'react'
import './index.scss'
import { Row, Col } from 'antd'
import HtVideo from '@/components/HtVideo'
import HtForm from './components/HtForm'
import IndexStep from '@/components/IndexStep'
import TweenOne from 'rc-tween-one'
import Children from 'rc-tween-one/lib/plugin/ChildrenPlugin'
import Swiper from "swiper"


import bannerImg from '@/images/newHome/banner.png'
import aeoIcon from '@/images/newHome/banner_icon_1.png'
import cctvIcon from '@/images/newHome/banner_icon_2.png'
import goodCourseArrows from '@/images/newHome/good_course_arrows.svg'
import goodTeacherArrows from '@/images/newHome/good_teacher_arrows.svg'
import goodeffectArrows from '@/images/newHome/good_effect_arrows.svg'
import bannerLogo from '@/images/newHome/banner_logo.png'
import bannerTitleIcon from '@/images/newHome/banner_font_icon.svg'
import bgIcon1 from '@/images/newHome/bg_icon_1.svg'
import bgIcon2 from '@/images/newHome/bg_icon_2.svg'
import bgIcon3 from '@/images/newHome/bg_icon_3.svg'
import bgIcon4 from '@/images/newHome/bg_icon_4.svg'
import textIcon1 from '@/images/newHome/text_icon_1.svg'
import textIcon2 from '@/images/newHome/text_icon_2.svg'
import textIcon3 from '@/images/newHome/text_icon_3.svg'
import teachingServerBg from '@/images/newHome/teaching_server_bg.png'
import teachingServerIcon1 from '@/images/newHome/teaching_server_icon_1.svg'
import teachingServerIcon2 from '@/images/newHome/teaching_server_icon_2.svg'
import teachingServerIcon3 from '@/images/newHome/teaching_server_icon_3.svg'
import teachingServerIcon4 from '@/images/newHome/teaching_server_icon_4.svg'
import cctvBgIcon from '@/images/newHome/cctv_bg.png'
import cctvPosterIcon from '@/images/newHome/cctv_poster.png'
import teachingBgIcon from '@/images/newHome/teaching_bg_icon.png'
import teachingIcon1 from '@/images/newHome/teaching_icon_1.svg'
import teachingIcon2 from '@/images/newHome/teaching_icon_2.svg'
import teachingIcon3 from '@/images/newHome/teaching_icon_3.svg'
import teachingIcon4 from '@/images/newHome/teaching_icon_4.svg'
import coursebg from '@/images/newHome/course_bg.svg'
import bookShadow from '@/images/newHome/book_shadow_icon.svg'
import playIcon from '@/images/newHome/play.svg'
import studentIcon from '@/images/newHome/student.svg'
import studentWhiteIcon from '@/images/newHome/student_white.svg'
import lessonsIcon from '@/images/newHome/lessons.svg'
import lessonsWhiteIcon from '@/images/newHome/lessons_white.svg'
import commentBgIcon from '@/images/newHome/comment_bg.png'
import symbalIcon from '@/images/newHome/symbal.png'
import bottomImg from '@/images/newHome/bottom_img.png'
import footerBg from '@/images/newHome/footer_bg.png'
import footerLogo from '@/images/newHome/footer_logo.png'
import ht from '@/images/newHome/ht.png'
import htName from '@/images/newHome/ht_name.png'



import { getCourseList, getTeacherList, getCommentList } from '@/apis/newHome'

TweenOne.plugins.push(Children)

class NewHome extends Component {

    state = {
        teachingServerList: [
            {
                icon: teachingServerIcon1,
                num: 0,
                title: '自主研发中文课程'
            },
            {
                icon: teachingServerIcon2,
                num: 0,
                title: '中文课堂覆盖国家和地区'
            },
            {
                icon: teachingServerIcon3,
                num: 0,
                title: '优选资深中文教师'
            },
            {
                icon: teachingServerIcon4,
                num: 0,
                title: '哈兔学员遍布全球'
            }
        ],
        teachingList: [
            [
                {
                    index: 1,
                    icon: teachingIcon1,
                    label: "真人实时教学",
                    content:
                        "在线视频面对面互动教学，能及时发现学员的学习状态，灵活调整适合学员的教学方法。",
                },
                {
                    index: 2,
                    icon: teachingIcon2,
                    label: "沉浸式教学",
                    content:
                        "将现实场号投射到在线课堂中，让学员在自然真实的环境中学习和使用中文，潜移默化地提升学习效果。",
                }
            ],
            [
                {
                    index: 3,
                    icon: teachingIcon3,
                    label: "多媒体课件",
                    content:
                        "课件充分利用多媒体技术:融合大量精美图片、音频、视频和GIF动图等内容，吸引学员注意力。",
                },
                {
                    index: 4,
                    icon: teachingIcon4,
                    label: "丰富课堂互动",
                    content:
                        "每节课设置有趣的交互型游戏，让学生充分参与到课章中，使教学更生动、练习更有趣!",
                }
            ]
        ],
        curTeachingIndex: 0,

        courseList: [],
        teacherList: [],
        commentList: []
    }

    getCourseList = () => {
        getCourseList({
            categoryId: 8
        }).then((res) => {
            console.log(res)
            this.setState({
                courseList: res.data
            }, () => {
                this.initCourseSwiper()
            })
        })
    }

    initCourseSwiper = () => {
        new Swiper('.swiper-container-course', {
            slidesPerView: 6,
            spaceBetween: 80,
            height: 'auto',
            loop: true,
            autoplay: {
              delay: 1000,
            }
          });
    }

    initTeacherSwiper = () => {
        new Swiper('.swiper-container-teacher', {
            slidesPerView: 3,
            spaceBetween: 44,
            height: 'auto',
            loop: true,
            autoplay: {
              delay: 3000,
            },
            pagination: {
                el: '.swiper-pagination-teacher',
                bulletClass : 'swiper-pagination-teacher-bullet',
                bulletActiveClass: 'swiper-pagination-teacher-bullet-active',
                clickable: true
            }
          });
    }

    getTeacherList = () => {
        getTeacherList({
            type: 1,
        }).then((res) => {
            this.setState({
                teacherList: res.data
            }, () => {
                this.initTeacherSwiper()
            })
        })
    }

    getCommentList = () => {
        getCommentList({
            appId: 'ihatoo',
        }).then((res) => {
            this.setState({
                commentList: res.data
            }, () => {
                this.initCommentSwiper()
            })
        })
    }

    initCommentSwiper = () => {
        new Swiper('.swiper-container-comment', {
            slidesPerView: 4,
            spaceBetween: 47,
            height: 'auto',
            loop: true,
            autoplay: {
              delay: 30000,
            },
            pagination: {
                el: '.swiper-pagination-comment',
                bulletClass : 'swiper-pagination-comment-bullet',
                bulletActiveClass: 'swiper-pagination-comment-bullet-active',
                clickable: true
            }
          });
    }

    selectTeaching = (it) => {
        this.setState({
            curTeachingIndex: it.index - 1
        })
    }

    toForm(){
        let formBox = document.getElementById('formBox')
        window.scrollTo({
            top: formBox.offsetTop
        })
        // window.ttq.track('ClickButton', {
        //     "query": window.location.hash.split("?")[1],
        //     // "test_event_code": 'TEST22538'
        // })
    }

    componentDidMount() {

        // window.ttq.track('ViewContent', {
        //     "query": window.location.hash.split("?")[1],
        //     // "test_event_code": 'TEST22538'
        // })

        document.title = '哈兔中文免费试读体验课-好课程，好老师，好效果！'

        const target = document.querySelectorAll(".num-animate-box");
        const callback = (entries, observer) => {
            entries.forEach(entrie => {
                if(entrie.isIntersecting){
                    this.state.teachingServerList[0].num = 40
                    this.state.teachingServerList[1].num = 120
                    this.state.teachingServerList[2].num = 3000
                    this.state.teachingServerList[3].num = 15000
                }else{
                    this.state.teachingServerList[0].num = 0
                    this.state.teachingServerList[1].num = 0
                    this.state.teachingServerList[2].num = 0
                    this.state.teachingServerList[3].num = 0
                }
            })

            this.setState({
                teachingServerList: this.state.teachingServerList
            })
        };
        const options = {};
        const observer = new IntersectionObserver(callback, options);
        target.forEach(el => {
            observer.observe(el);
        })
        
        this.getCourseList()
        this.getTeacherList()
        this.getCommentList()
    }

    render() {
        return (
            <div className="new-home">

                <div className='banner-box'>
                    <img className='banner-img' src={bannerImg} />

                    <div className="banner-content">
                        <div className="g-container-width banner-width-view">
                            <div className="content">

                                <div className='logo-box'>
                                    <img className='logo-img' src={bannerLogo} />
                                </div>
                                <div className="tag-box">
                                    <img className="aeo-icon" src={aeoIcon} />
                                    <img className="cctv-icon" src={cctvIcon} />
                                </div>

                                <h2 className="banner-title">
                                    <img className='banner-font-icon' src={bannerTitleIcon} />
                                    <p className='banner-title-desc'>150000+全球华人家长的共同选择</p>
                                </h2>

                                <div className="good-course-box">
                                    <div className="hatu-tag good-course">好课程</div>
                                    <img className="arrows-icon" src={goodCourseArrows} />
                                </div>

                                <div className="good-teacher-box">
                                    <div className="hatu-tag good-teacher">好老师</div>
                                    <img className="arrows-icon" src={goodTeacherArrows} />
                                </div>

                                <div className="good-effect-box">
                                    <div className="hatu-tag good-effect">好效果</div>
                                    <img className="arrows-icon" src={goodeffectArrows} />
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

                <div className='form-box' id='formBox'>
                    <img className='bg-icon bg-icon-1' src={bgIcon1} />
                    <img className='bg-icon bg-icon-2' src={bgIcon2} />
                    <img className='bg-icon bg-icon-3' src={bgIcon3} />
                    <img className='bg-icon bg-icon-4' src={bgIcon4} />

                    <div className='g-container-width'>
                        <div className='content'>

                            <div className='text-box'>
                                <h3 className='title'>中文学习大礼包</h3>
                                <ul className='text-list-box'>
                                    <li className='text-list-item'>
                                        <img className='item-text-icon' src={textIcon1} />
                                        <div className='item-text-box'>
                                            <h5 className='text-title'>2节试读体验课</h5>
                                            <p className='text-desc'>1V1名师课、评测报告、成长规划、名师答疑</p>
                                        </div>
                                    </li>
                                    {/* <li className='text-list-item'>
                                        <img className='item-text-icon' src={textIcon2} />
                                        <div className='item-text-box'>
                                            <h5 className='text-title'>16节中华文化兴趣课</h5>
                                            <p className='text-desc'>《城市与美食》从城市发展、经典故事、景点科普、中华美食、艺术文物等多角度详细介绍中国经典城市风貌，为孩子呈现一个完整的中华城市印象。</p>
                                        </div>
                                    </li> */}
                                    <li className='text-list-item'>
                                        <img className='item-text-icon' src={textIcon3} />
                                        <div className='item-text-box'>
                                            <h5 className='text-title'>哈兔书房VIP</h5>
                                            <p className='text-desc'>书房内含1000多本AI交互动画书，每1本书都有丰富的动画、多媒体和互动效果，孩子在阅读时通过多点触摸、摇晃动作玩游戏的方式与动画书指尖互动，让孩子随时随地畅享阅读的喜悦！</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div className='form'>
                                <HtForm history={this.props.history} />
                            </div>

                        </div>
                    </div>
                </div>

                <div className='teaching-server' style={{ backgroundImage: `url(${teachingServerBg})` }}>
                    <div className='g-container-width'>
                        <div className='content'>
                            <h3 className='title'>提供高品质教学服务</h3>
                            <Row className='list' gutter={40}>
                                {
                                    this.state.teachingServerList.map((item, index) => (
                                        <Col span={6} className='list-item' key={index}>
                                            <div className='list-item-content'>
                                                <img className='icon' src={item.icon} />
                                                <div className='num num-animate-box'>
                                                    <TweenOne
                                                        animation={{
                                                            Children: {
                                                                value: item.num,
                                                                floatLength: 0,
                                                                formatMoney: {
                                                                    thousand: ','
                                                                }
                                                            },
                                                            duration: 1000,
                                                        }}
                                                    ></TweenOne>+
                                                </div>
                                                <p className='desc'>{item.title}</p>
                                            </div>
                                        </Col>
                                    ))
                                }
                            </Row>
                        </div>
                    </div>
                </div>


                <div className="cctv" style={{ backgroundImage: `url(${cctvBgIcon})` }}>
                    <div className="g-container-width">

                        <h2 className="content-title">值得信赖，央视专题报道</h2>
                        <div className="content">
                            <div className="video-box">
                                <HtVideo src="https://hatu-cdn.oss-cn-hangzhou.aliyuncs.com/hatu-unnc/assets/index/CCTV_video.mp4" poster={cctvPosterIcon} />
                            </div>
                            <div className="desc-box">
                                <h5 className="desc-title">央视中文国际频道（CCTV-4）讲述“哈兔故事”</h5>
                                <ul className="desc-text-box">
                                    <li className="desc-text">
                                        <p className='text'>哈兔中文网络学院创办于2012年，专注为海外华侨华人孩子和全球中文爱好者提供专业在线中文教育。哈兔的在线中文课堂已覆盖全球<b>120</b>多个国家和地区，在线注册学员已超过<b>150,000</b>人，在线专业资深老师超过<b>3,000</b>人。</p>
                                    </li>
                                    <li className="desc-text">
                                        <p className='text'>2018年10月，中央电视台《走遍中国》栏目摄制组走进哈兔中文，进行了为期一周的专题采访，对哈兔中文创始人朱敏院长进行了专访，深度介绍了哈兔创始团队坚持 让天下人学中文不再难”的使命，面向全球开展在线中文教育和传播中华文化的心路历程。</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="classroom">

                    <img
                        className='classroom-bg-img'
                        src={teachingBgIcon}
                    />

                    <div className="g-container-width">

                        <h2 className="content-title">一个有趣的在线中文课堂</h2>

                        <p className='sub-content-title'>趣味与实用兼具的在线中文课堂</p>

                        <div className="content">

                            <div className="classroom-info">

                                <div className="video-box">
                                    <h6 className="title">{[...this.state.teachingList[0], ...this.state.teachingList[1]][this.state.curTeachingIndex].label}</h6>
                                    <p className="desc">{[...this.state.teachingList[0], ...this.state.teachingList[1]][this.state.curTeachingIndex].content}</p>
                                    <div className="video-conteainer">
                                        <HtVideo src="https://hatu-cdn.oss-cn-hangzhou.aliyuncs.com/hatu-unnc/assets/index/teaching_video.mp4" />
                                    </div>
                                </div>

                                <div className="teaching-box">
                                    {
                                        this.state.teachingList.map((item, index) => (
                                            <ul className="list" key={index}>
                                                {
                                                    item.map((it, ind) => (
                                                        <li
                                                            key={ind}
                                                            className={`list-item ${(it.index - 1) === this.state.curTeachingIndex ? 'list-item-active' : ''}`}
                                                            onClick={this.selectTeaching.bind(this, it)}
                                                        >
                                                            <span className="num">{it.index}</span>
                                                            <img className="icon" src={it.icon} />
                                                            <p className="value">{it.label}</p>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className='course-box' style={{ backgroundImage: `url(${coursebg})` }}>
                    <div className='content'>

                        <div className='title-box'>
                            <h3 className='title'>好课程，自主研发中文课程</h3>
                            <p className='title-desc'>哈兔教研团队自主研发专为海外华人青少儿定制的中文课程，均获得国家版权中心认证</p>
                            <p className='title-desc'>3大类40+中文课程满足不同水平学习者的不同学习需求</p>
                        </div>

                        <div className='swiper-box'>
                            <div className='swiper-container swiper-container-course'>
                                <div className="swiper-wrapper">
                                    {
                                        this.state.courseList.map((item, index) => (
                                            <div className='swiper-slide swiper-slide-item' key={index}>
                                                <img className="book" src={item.verticalImages} alt={item.title} />
                                                <img className="book-shadow" src={bookShadow} />
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className='teacher-box'>
                    <div className='content'>

                        <div className='g-container-width'>
                            <div className='title-box'>
                                <h3 className='title'>好老师，懂教育爱孩子</h3>
                                <p className='title-desc'>全球3000+资深老师，均来自于国内外知名大学，在线教学经验丰富，精通儿童教育心理学，在趣味课堂中</p>
                                <p className='title-desc'>亦师亦友相伴成长，让学员的每一堂课都学有所获。</p>
                            </div>

                            <div className='swiper-box'>
                                <div className='swiper-container swiper-container-teacher'>
                                    <div className="swiper-wrapper">

                                        {
                                            this.state.teacherList.map((arr, index) => (
                                                <div className='swiper-slide' key={index}>
                                                    <div className='swiper-slide-item'>
                                                        <div className='pic-box'>
                                                            <HtVideo src={arr.video} isDialogPlay={true}>
                                                                <div className="teacher-img-box">
                                                                    <img className="teacher-pic" src={arr.photo} />
                                                                    <div className="teacher-info-box">
                                                                        <div className="teacher-text">
                                                                            <p className="teacher-name">{ arr.name }</p>
                                                                            <p className="teahcer-education">{ arr.school } { arr.highestEducation }</p>
                                                                        </div>
                                                                        <img className="play-icon" src={playIcon}/>
                                                                    </div>
                                                                </div>
                                                            </HtVideo>
                                                        </div>

                                                        <div className="teacher-introduce-box">
                                                            <p className="teacher-lang">掌握语言：{ arr.language }</p>
                                                            <div className="teacher-experience">
                                                                <div className="experience-item">
                                                                    <img className="icon" src={studentIcon} />
                                                                    <img className="icon icon-white" src={studentWhiteIcon} />
                                                                    <p className="value">{ arr.studentNum }名在读学生</p>
                                                                </div>
                                                                <div className="experience-item">
                                                                    <img className="icon" src={lessonsIcon} />
                                                                    <img className="icon icon-white" src={lessonsWhiteIcon}/>
                                                                    <p className="value">累计授课{ arr.lessonNum }节</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }

                                    </div>
                                </div>
                            </div>

                            <div className="swiper-pagination-teacher"></div>
                        </div>

                    </div>
                </div>
               
                <div className="comment">

                    <div className="title-box">
                        <p className="title">学员和家长的评价</p>
                    </div>

                    <img className="bg-img" src={commentBgIcon}/>

                    <div className="g-container-width">
                        <div className="content">
                            <div className="comment-box">

                                <div className='swiper-box'>
                                    <div className='swiper-container swiper-container-comment'>
                                        <div className="swiper-wrapper">

                                            {
                                                this.state.commentList.map((arr, index) => (
                                                    <div className='swiper-slide' key={index}>
                                                        <div className="comment-item">
                                                            <div className="video-box">
                                                                <img className="img" src={arr.cover}/>
                                                            </div>
                                                            <div className="info-box">
                                                                <p className="name">{ arr.studentName }</p>

                                                                <div className="info-text">
                                                                    <span className="line"></span>
                                                                    <img className="symbal" src={symbalIcon} />
                                                                    <p className="comment g-ellipsis-eight">{arr.remarks }</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            }

                                        </div>
                                    </div>
                                </div>

                                <div className="swiper-pagination-comment"></div>

                            </div>
                        </div>
                    </div>

                </div>

                <div className="step-box">
                    <div className="g-container-width">
                        <h2 className="content-title">简单3步，免费试听！</h2>

                        <div className="steps-box">
                            <IndexStep />
                        </div>

                        <div onClick={this.toForm}>
                            <div className="apply-btn">立即免费领取试读体验课</div>
                        </div>
                    </div>
                </div>

                <div className='bottom-img-box'>
                    <img className='bottom-img' src={bottomImg} />
                </div>

                <div className='foonter-box' style={{ backgroundImage: `url(${footerBg})` }}>
                    <div className='g-container-width'>
                        <div className='logo-box'>
                            <img className='footer-logo' src={footerLogo} />
                        </div>

                        <div className="copyright">
                            <p className="copyright-num">IHATOOS2020哈免中文网络科技有限公司-浙ICP备15040512号</p>
                            <p className="aeo">国高认证</p>
                        </div>
                    </div>
                </div>

                <div className='fiexd-btn-box'>
                    <div className='g-container-width'>
                        <div className='content'>
                            <div className='text-box'>
                                <img className='img' src={ht} />
                                <div className='text'>
                                    <img className='text-img' src={htName} />
                                    <p className='desc'>好老师 好课程 好效果</p>
                                </div>
                            </div>
                            <div className='btn' onClick={this.toForm}>立即免费试读体验</div>
                        </div>
                    </div>
                </div>

            </div >
        )
    }
}

export default NewHome